/**
 * Decal registration: the parser and property formatter.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseDecal } from './parser';
import { formatDecalProperties } from './propertyFormatter';
const decalRegistration = {
    typeName: 'Decal',
    parser: parseDecal,
    propertyFormatter: formatDecalProperties,
};
nodeRegistry.register(decalRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map